// utils/toast.js
import { toast } from "react-toastify";

const DEFAULT_POSITION = "bottom-right";
const DEFAULT_AUTO_CLOSE = 3000;

const normalizarMensagem = (msg) => {
  if (!msg) return "Operação processada.";

  if (typeof msg === "string") return msg;

  if (msg?.message) return String(msg.message);

  return String(msg);
};

const gerarToastId = (tipo, msg) => {
  const texto = normalizarMensagem(msg)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .substring(0, 80);

  return `${tipo}-${texto}`;
};

const toastOptions = (tipo, msg, options = {}) => ({
  toastId: options.toastId || gerarToastId(tipo, msg),

  position: options.position || DEFAULT_POSITION,
  autoClose: options.autoClose ?? DEFAULT_AUTO_CLOSE,

  hideProgressBar: options.hideProgressBar ?? false,
  closeOnClick: options.closeOnClick ?? true,
  pauseOnHover: options.pauseOnHover ?? false,
  pauseOnFocusLoss: options.pauseOnFocusLoss ?? false,
  draggable: options.draggable ?? true,

  newestOnTop: true,
  closeButton: true,

  ...options,
});

export const showInfo = (msg, options = {}) => {
  const mensagem = normalizarMensagem(msg);
  toast.info(mensagem, toastOptions("info", mensagem, options));
};

export const showError = (msg, options = {}) => {
  const mensagem = normalizarMensagem(msg);
  toast.error(mensagem, {
    ...toastOptions("error", mensagem, options),
    autoClose: options.autoClose ?? 5000,
  });
};

export const showSuccess = (msg, options = {}) => {
  const mensagem = normalizarMensagem(msg);
  toast.success(mensagem, toastOptions("success", mensagem, options));
};

export const showWarning = (msg, options = {}) => {
  const mensagem = normalizarMensagem(msg);
  toast.warning(mensagem, toastOptions("warning", mensagem, options));
};

export const fecharToasts = () => {
  toast.dismiss();
};

export const fecharToast = (toastId) => {
  if (!toastId) return;
  toast.dismiss(toastId);
};